import React from "react";
import { useField } from "formik";
import FormInput from "../../../components/reports/information/FormInput";

const TextfieldWrapper = (props) => {
  const [field, meta] = useField(props);
  return <FormInput {...props} {...field} error={meta.touched && meta.error ? meta.error : ""} />;
};

export default TextfieldWrapper;
